import React from "react";
import { MessageSquareText } from "lucide-react";
import { SMS_TERMS } from "../mock";
import { LegalPage } from "../components/LegalPage";
import useScrollReveal from "../hooks/useScrollReveal";
import useSEO from "../hooks/useSEO";

export default function TermsConditions() {
  useScrollReveal();
  useSEO({
    title: "SMS Terms & Conditions | Miller & Miller Services LLC",
    description:
      "SMS Terms & Conditions for Miller & Miller Services LLC. Learn about message types, frequency, opt-in and opt-out methods, fees, and help for our text messaging program.",
    path: "/terms-conditions",
  });
  return (
    <LegalPage
      icon={MessageSquareText}
      badge="SMS Program"
      title="Terms & Conditions"
      breadcrumb="Terms & Conditions"
      updated={SMS_TERMS.updated}
      intro={SMS_TERMS.intro}
      sections={SMS_TERMS.sections}
    />
  );
}
